import { MouseEventHandler } from 'react'

import clsx from 'clsx'

import IconButton from '@/components/view/atoms/button/IconButton'
import { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import Text from '@/components/view/atoms/text/Text'

interface Props {
  onClickPrev?: MouseEventHandler<HTMLButtonElement>
  onClickNext?: MouseEventHandler<HTMLButtonElement>
  value: string
}

const TextPager = ({ onClickPrev, onClickNext, value }: Props) => {
  return (
    <div className={clsx('flex items-center gap-x-2')}>
      <IconButton
        color={onClickPrev ? IconColor.PRIMARY : IconColor.DISABLED}
        type={IconType.LEFT}
        onClick={onClickPrev}
        disabled={!onClickPrev}
      />
      <Text weight='bold' size={16}>
        {value}
      </Text>
      <IconButton
        color={onClickNext ? IconColor.PRIMARY : IconColor.DISABLED}
        type={IconType.RIGHT}
        onClick={onClickNext}
        disabled={!onClickNext}
      />
    </div>
  )
}

export default TextPager
